import React from 'react';
import HeroContent from './HeroContent';
import HeroTerminal from './HeroTerminal';

export const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-slate-50/50 to-white pt-8 pb-14 sm:pt-12 sm:pb-20 lg:pt-14 lg:pb-24">
      {/* Subtle ambient gradient mesh for depth */}
      <div className="absolute top-0 right-1/4 w-96 h-96 bg-indigo-100/40 rounded-full blur-3xl pointer-events-none -z-10" />
      <div className="absolute top-1/3 left-10 w-80 h-80 bg-purple-100/30 rounded-full blur-3xl pointer-events-none -z-10" />

      <div className="w-full max-w-[1680px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-28">
        
        {/* Main Grid: Left Hero Copy & Search + Right Monitor Preview */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 xl:gap-14 items-center">
          
          {/* Left Column */}
          <div className="lg:col-span-6 xl:col-span-6">
            <HeroContent />
          </div>

          {/* Right Column */}
          <div className="lg:col-span-6 xl:col-span-6 mt-6 lg:mt-0 flex justify-center lg:justify-end w-full">
            <HeroTerminal />
          </div>

        </div>

      </div>
    </section>
  );
};

export default HeroSection;
